import React, {createContext, memo, useContext, useEffect, useState} from 'react';
import { Admin } from 'react-admin';
import Layout from 'components/Layout';
import Dashboard from 'components/Dashboard'
import ErrorBoundary from 'ErrorBoundary';
import Menu from './menu';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Auth0Provider, useAuth0 } from "@auth0/auth0-react";
import authProvider from './utils/authProvider';
import Login from './components/Login';
import theme from './utils/theme';
import { buildAppGraphQLProvider, createApolloClient } from "./data-provider/dataProvider";

import service from './admins/service';
import customer from './admins/customer';
import device from './admins/device';
import userAdmin from './admins/user';

const apiHost = process.env.REACT_APP_API_URL;
const servicesHost = process.env.REACT_APP_SERVICES_URL;

export const HostContext = createContext({
  apiHost: '', 
  apiToken: null, 
  setApiToken: () => {},
  user: null, 
  setUser: () => {},
  activeOrganization: null,
  setActiveOrganization: () => {},
  dataProvider: null
});

function App() {
  const [apiToken, setApiToken] = useState(null);
  const [user, setUser] = useState(null);
  const [dataProvider, setDataProvider] = useState(false);

  useEffect(() => {
    
    const client = createApolloClient({
      uri: `${apiHost}/api/graphql`,
      apiToken
    });

    buildAppGraphQLProvider({ client }).then(d => setDataProvider(() => d));
  }, [apiToken]);
  

  return (
    <ErrorBoundary user={user}>
        <HostContext.Provider value={{apiHost, servicesHost, apiToken, setApiToken, dataProvider, user, setUser}}>
          <DndProvider backend={HTML5Backend}>
            <Auth0Provider
              domain={process.env.REACT_APP_AUTH0_DOMAIN}
              clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
              redirect_uri={window.location.origin}
              audience={'https://v1.panoscape.app'}
            >
              <AppAdmin />
            </Auth0Provider>
          </DndProvider>
        </HostContext.Provider>
    </ErrorBoundary>
  );
}

const AppAdmin = memo(() => {
  const { isAuthenticated, handleRedirectCallback, getIdTokenClaims, getAccessTokenSilently, logout, user } = useAuth0();
  const { setUser } = useContext(HostContext);

  const {dataProvider} = useContext(HostContext);

  const {apiToken, setApiToken} = useContext(HostContext);

  const auth0 = {
    handleRedirectCallback,
    getIdTokenClaims,
    getAccessTokenSilently,
    logout
  };

  useEffect(() => {

    const run = async () => {
      if (!isAuthenticated && !apiToken ) {
        return;
      }

      const token = await getAccessTokenSilently();

      setApiToken(token);
    }

    run();

  }, [isAuthenticated, apiToken, getAccessTokenSilently, setApiToken]);

  useEffect(() => {
    setUser(user);
  }, [user, setUser]);

  if(!isAuthenticated) {
    return (<Login />);
  }

  if (!dataProvider) {
    return <div>Loading</div>;
  }

  return (
    <Admin
      menu={Menu}
      layout={Layout}
      theme={theme}
      dashboard={Dashboard}
      loginPage={Login}
      disableTelemetry
      authProvider={authProvider(auth0)}
      dataProvider={dataProvider}
    >
      {service()}
      {customer()}
      {device()}
      {userAdmin()}
    </Admin>
  )
})

export default App;
